import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import Home from '@/views/Home'
import Login from '@/views/Login'
import Agents from '@/views/Agents'
import Agent from '@/views/Agent'
import Observations from '@/views/Observations'
import MaterialPortal from '@/views/MaterialPortal'
import Material from '@/views/Material'
import NotFound404 from '@/views/NotFound404'
import Summary from '@/views/Summary'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: false,
      }
    },
    {
      path: '/agents',
      name: 'agents',
      component: Agents,
      exact: true,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/agents/:slug',
      name: 'agent',
      component: Agent,
      exact: true,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/observations',
      name: 'observations',
      component: Observations,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/material-portal',
      name: 'material-portal',
      component: MaterialPortal,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/material-portal/:resourceType/:resourceId',
      name: 'material',
      props: true,
      component: Material
    },
    {
      path: '*',
      name: 'non-existing',
      component: NotFound404
    },
    {
      path: '/agents/:slug/summary',
      name: 'summary',
      component: Summary,
      props: true,
      meta: {
        hideNavbar: true,
      }
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next()
    } else {
      next('/login')
    }
  } else {
    next()
  }
})

export default router
